import actions from "./actions";
export default {
  namespaced: true,
  state() {
    return {
      error: "",
      asicMiners: [],
      gpuMiners: [],
      allMiners: [],
      dbMiners: [],
      exchangeRate: 1,
      withHeat: false,
      globalPowerCost: 19,
      globalHeatPrice: 150,
      onlyProfitable: false,
      advancedFilters: "fastestReturn",
      list: false,
      algorithmsFilter: [],
    };
  },
  getters: {
    getMiners(state: any) {
      return state.allMiners;
    },
    getAsicMiners(state: any) {
      return state.asicMiners;
    },
    getGpuMiners(state: any) {
      return state.gpuMiners;
    },
    getDbMiners(state: any) {
      return state.dbMiners;
    },
    getExchangeRate(state: any) {
      return state.exchangeRate;
    },
    getGlobalPowerCost(state: any) {
      return state.globalPowerCost;
    },
    getGlobalHeatPrice(state: any) {
      return state.globalHeatPrice;
    },
    getProfitable(state: any) {
      return state.onlyProfitable;
    },
    getAdvancedFilter(state: any) {
      return state.advancedFilters;
    },
    getAlgorithmsFilter(state: any) {
      return state.algorithmsFilter;
    },
    getList(state: any) {
      return state.list;
    },
    getMinersType(state: any) {
      return state.withHeat;
    },
  },
  mutations: {
    setMiners(state: any) {
      state.allMiners = [...state.asicMiners, ...state.gpuMiners];
    },
    setError(state: any, payload: any) {
      state.error = payload;
    },
    setExchangeRate(state: any, payload: any) {
      state.exchangeRate = payload;
    },
    setGlobalPowerCost(state: any, payload: any) {
      state.globalPowerCost = payload;
    },
    setGlobalHeatPrice(state: any, payload: any) {
      state.globalHeatPrice = payload;
    },
    setProfitable(state: any, payload: any) {
      state.onlyProfitable = payload;
    },
    setAdvancedFilter(state: any, payload: any) {
      state.advancedFilters = payload;
    },
    setAlgorithmsFilter(state: any, payload: any) {
      state.algorithmsFilter = payload;
    },
    setList(state: any, payload: any) {
      state.list = payload;
    },
    setAsicMiners(state: any, miners: object[]) {
      state.asicMiners = miners;
    },
    setGpuMiners(state: any, miners: object[]) {
      state.gpuMiners = miners;
    },
    setDbMiners(state: any, miners: object[]) {
      state.dbMiners = miners;
    },
    setMinersType(state: any, payload: any) {
      state.withHeat = payload;
    },
    setMinersProfits(state: any) {
      for (const miner of state.asicMiners) {
        const profits = calculateProfits(
          state.globalPowerCost,
          Number(miner.power),
          miner.revenue,
          miner.price,
          state.globalHeatPrice,
          state.withHeat
        );
        miner.profits = profits;
      }
      for (const miner of state.gpuMiners) {
        const profits = calculateProfits(
          state.globalPowerCost,
          Number(miner.power),
          miner.revenue,
          miner.price,
          state.globalHeatPrice,
          state.withHeat
        );
        miner.profits = profits;
      }
    },
    async calculateMinerRevenue(state: any, isAsic: boolean) {
      if (isAsic) {
        for (const miner of state.asicMiners) {
          const algorithm: keyof typeof coins.coinsAsic = miner.algorithm;
          const minerId: number = miner.id;
          const dbStorageRevenue = await state.dbMiners.find(
            (user: any) => user.minerID == minerId
          );
          if (dbStorageRevenue === undefined) {
            const revenue = await getRevenue(
              miner.name,
              miner.hashrate,
              Number(miner.power),
              state.globalPowerCost,
              coins.coinsAsic[algorithm],
              true, //// isASIC?
              state.exchangeRate,
              miner.units
            );
            miner.revenue = revenue;

            state.dbMiners.push({
              minerID: minerId,
              revenue: revenue,
              created: new Date()
                .toLocaleString("sv")
                .slice(0, 19)
                .replace("T", " "),
            });
            if (revenue !== undefined) {
              postMinerToDB({
                minerID: minerId,
                revenue: revenue,
                created: new Date()
                  .toLocaleString("sv")
                  .slice(0, 19)
                  .replace("T", " "),
              });
            }
          } else {
            miner.revenue = Number(dbStorageRevenue.revenue);
          }

          const profits = calculateProfits(
            state.globalPowerCost,
            Number(miner.power),
            miner.revenue,
            miner.price,
            state.globalHeatPrice,
            state.withHeat
          );
          miner.profits = profits;
        }
      } else {
        for (const miner of state.gpuMiners) {
          const algorithm: keyof typeof coins.coinsGPU = miner.algorithm;
          const minerId: number = miner.id;

          const dbStorageRevenue = state.dbMiners.find(
            (user: any) => user.minerID == minerId
          );
          if (dbStorageRevenue === undefined) {
            const revenue = await getRevenue(
              miner.name,
              miner.hashrate,
              Number(miner.power),
              state.globalPowerCost,
              coins.coinsGPU[algorithm],
              false, //// isASIC?
              state.exchangeRate,
              miner.units
            );
            miner.revenue = revenue;

            state.dbMiners.push({
              minerID: minerId,
              revenue: revenue,
              created: new Date()
                .toLocaleString("sv")
                .slice(0, 19)
                .replace("T", " "),
            });
            if (revenue !== undefined) {
              postMinerToDB({
                minerID: minerId,
                revenue: revenue,
                created: new Date()
                  .toLocaleString("sv")
                  .slice(0, 19)
                  .replace("T", " "),
              });
            }
          } else {
            miner.revenue = Number(dbStorageRevenue.revenue);
          }

          const profits = calculateProfits(
            state.globalPowerCost,
            Number(miner.power),
            miner.revenue,
            miner.price,
            state.globalHeatPrice,
            state.withHeat
          );
          miner.profits = profits;
        }
      }
    },
    removeCachedMinersRevenues(state: any) {
      for (const miner of state.gpuMiners) {
        const minerId: number = miner.id;
        localStorage.removeItem(`${minerId}`);
      }
      for (const miner of state.asicMiners) {
        const minerId: number = miner.id;
        localStorage.removeItem(`${minerId}`);
      }
    },
    removeExchangeRate() {
      localStorage.removeItem(`exchangeRate`);
    },
  },
  actions: actions,
  modules: {},
};

import { coins } from "../../tools/getAlgorithm";

async function postMinerToDB(body: any) {
  const fd = new FormData();
  for (const prop in body) {
    fd.append(prop, body[prop]);
  }
  fetch(`/kalkulator/postMiner.php`, { method: "POST", body: fd });
}

async function getRevenue(
  name: string,
  HASHRATERAW: number,
  POWER: number,
  POWER_COST: number,
  ALGORITHM: string,
  isASIC: boolean,
  exchangeRate: number,
  units: string
) {
  try {
    const HASHRATE = recalculateHashrate(ALGORITHM, units, HASHRATERAW);

    const baseurl = "https://whattomine.com/";

    const correctedAlgorithm = ["sha256", "scrypt", "x11", "qk", "qb"].includes(
      ALGORITHM
    )
      ? `${ALGORITHM}f`
      : ALGORITHM;

    const correctHashRateTitle = ALGORITHM === "scrypt" ? "hash_rate" : "hr";
    const correctPowerTitle = ALGORITHM === "scrypt" ? "power" : "p";

    const restOfUrl = isASIC
      ? `asic?factor[${ALGORITHM}_${correctHashRateTitle}]=${HASHRATE}&factor[${ALGORITHM}_${correctPowerTitle}]=${POWER}&${correctedAlgorithm}=true&factor[cost_currency]=USD&sort=Profit24&volume=0&revenue=24h&dataset=Main&commit=Calculate`
      : `coins?factor[${ALGORITHM}_hr]=${HASHRATE}&factor[${ALGORITHM}_p]=${POWER}&${correctedAlgorithm}=true&factor[cost_currency]=USD&sort=Profit24&volume=0&revenue=24h&dataset=Main&commit=Calculate`;

    const url = `/kalkulator/proxy.php?url=${encodeURIComponent(
      baseurl + restOfUrl
    )}`;

    // const url = isASIC
    //   ? `https://whattomine.com/asic?factor%5Bsha256_hr%5D=${HASHRATE}&factor%5Bsha256_p%5D=${POWER}&factor%5Bscrypt_hash_rate%5D=${HASHRATE}&factor%5Bscrypt_power%5D=${POWER}&${ALGORITHM}=true&factor%5Bx11_hr%5D=${HASHRATE}&factor%5Bx11_p%5D=${POWER}&factor%5Bsia_hr%5D=${HASHRATE}&factor%5Bsia_p%5D=${POWER}&factor%5Bqk_hr%5D=${HASHRATE}&factor%5Bqk_p%5D=${POWER}&factor%5Bqb_hr%5D=${HASHRATE}&factor%5Bqb_p%5D=${POWER}&factor%5Bmg_hr%5D=${HASHRATE}&factor%5Bmg_p%5D=${POWER}&factor%5Bsk_hr%5D=${HASHRATE}&factor%5Bsk_p%5D=${POWER}&factor%5Blbry_hr%5D=${HASHRATE}&factor%5Blbry_p%5D=${POWER}&factor%5Bbk14_hr%5D=${HASHRATE}&factor%5Bbk14_p%5D=${POWER}&factor%5Bcn_hr%5D=${HASHRATE}&factor%5Bcn_p%5D=${POWER}&factor%5Bcst_hr%5D=${HASHRATE}&factor%5Bcst_p%5D=${POWER}&factor%5Beq_hr%5D=${HASHRATE}&factor%5Beq_p%5D=${POWER}&factor%5Blrev2_hr%5D=${HASHRATE}&factor%5Blrev2_p%5D=${POWER}&factor%5Bbcd_hr%5D=${HASHRATE}&factor%5Bbcd_p%5D=${POWER}&factor%5Bl2z_hr%5D=${HASHRATE}&factor%5Bl2z_p%5D=${POWER}&factor%5Bkec_hr%5D=${HASHRATE}&factor%5Bkec_p%5D=${POWER}&factor%5Bgro_hr%5D=${HASHRATE}&factor%5Bgro_p%5D=${POWER}&factor%5Besg_hr%5D=${HASHRATE}&factor%5Besg_p%5D=${POWER}&factor%5Bct32_hr%5D=${HASHRATE}&factor%5Bct32_p%5D=${POWER}&factor%5Bhh_hr%5D=${HASHRATE}&factor%5Bhh_p%5D=${POWER}&factor%5Bkd_hr%5D=${HASHRATE}&factor%5Bkd_p%5D=${POWER}&factor%5Bhk_hr%5D=${HASHRATE}&factor%5Bhk_p%5D=${POWER}&factor%5Brmx_hr%5D=${HASHRATE}&factor%5Brmx_p%5D=1350.0&factor%5Bcost%5D=0.29&factor%5Bcost_currency%5D=USD&sort=Profit24&volume=0&revenue=24h&factor%5Bexchanges%5D%5B%5D=&factor%5Bexchanges%5D%5B%5D=binance&factor%5Bexchanges%5D%5B%5D=bitfinex&factor%5Bexchanges%5D%5B%5D=bitforex&factor%5Bexchanges%5D%5B%5D=bittrex&factor%5Bexchanges%5D%5B%5D=coinex&factor%5Bexchanges%5D%5B%5D=exmo&factor%5Bexchanges%5D%5B%5D=gate&factor%5Bexchanges%5D%5B%5D=graviex&factor%5Bexchanges%5D%5B%5D=hitbtc&factor%5Bexchanges%5D%5B%5D=ogre&factor%5Bexchanges%5D%5B%5D=poloniex&factor%5Bexchanges%5D%5B%5D=xeggex&dataset=Main&commit=Calculate`
    //   : `https://www.whattomine.com/coins?aq_3070=3&aq_69xt=0&aq_68xt=0&aq_68=0&aq_67xt=0&aq_66xt=0&aq_vii=0&aq_5700xt=0&aq_5700=0&aq_5600xt=0&aq_vega64=0&aq_vega56=0&aq_4090=0&aq_4080=0&aq_47Ti=0&aq_47=0&aq_46Ti=0&aq_39Ti=0&aq_3090=0&aq_38Ti=0&aq_3080=0&aq_37Ti=0&aq_3060Ti=0&aq_3060=0&aq_66=0&aq_55xt8=0&aq_580=0&aq_570=0&aq_480=0&aq_470=0&aq_fury=0&aq_380=0&aq_a5=0&aq_a45=0&aq_a4=0&aq_a2=0&aq_2080Ti=0&aq_2080=0&aq_2070=0&aq_2060=0&aq_166s=0&aq_1660Ti=0&aq_1660=0&aq_1080Ti=0&aq_1080=0&aq_1070Ti=0&aq_1070=0&aq_10606=0&aq_1050Ti=0&${ALGORITHM}=true&factor%5Beth_hr%5D=${HASHRATE}&factor%5Beth_p%5D=${POWER}&factor%5Be4g_hr%5D=${HASHRATE}&factor%5Be4g_p%5D=${POWER}&factor%5Bzh_hr%5D=${HASHRATE}&factor%5Bzh_p%5D=${POWER}&factor%5Bcnh_hr%5D=${HASHRATE}&factor%5Bcnh_p%5D=${POWER}&factor%5Bcng_hr%5D=${HASHRATE}&factor%5Bcng_p%5D=${POWER}&factor%5Bs5r_hr%5D=${HASHRATE}&factor%5Bs5r_p%5D=${POWER}&factor%5Bcx_hr%5D=${HASHRATE}&factor%5Bcx_p%5D=${POWER}&factor%5Bds_hr%5D=${HASHRATE}&factor%5Bds_p%5D=${POWER}&factor%5Bcc_hr%5D=${HASHRATE}&factor%5Bcc_p%5D=${POWER}&factor%5Bcr29_hr%5D=${HASHRATE}&factor%5Bcr29_p%5D=${POWER}&factor%5Bhh_hr%5D=${HASHRATE}&factor%5Bhh_p%5D=${POWER}&factor%5Bct32_hr%5D=${HASHRATE}&factor%5Bct32_p%5D=${POWER}&factor%5Beqb_hr%5D=${HASHRATE}&factor%5Beqb_p%5D=${POWER}&factor%5Bb3_hr%5D=${HASHRATE}&factor%5Bb3_p%5D=${POWER}&factor%5Bns_hr%5D=${HASHRATE}&factor%5Bns_p%5D=${POWER}&factor%5Bal_hr%5D=${HASHRATE}&factor%5Bal_p%5D=${POWER}&factor%5Bops_hr%5D=${HASHRATE}&factor%5Bops_p%5D=${POWER}&factor%5Bir_hr%5D=${HASHRATE}&factor%5Bir_p%5D=${POWER}&factor%5Bzlh_hr%5D=${HASHRATE}&factor%5Bzlh_p%5D=${POWER}&factor%5Bkpw_hr%5D=${HASHRATE}&factor%5Bkpw_p%5D=${POWER}&factor%5Bppw_hr%5D=${HASHRATE}&factor%5Bppw_p%5D=${POWER}&factor%5Bnx_hr%5D=${HASHRATE}&factor%5Bnx_p%5D=${POWER}&factor%5Bfpw_hr%5D=${HASHRATE}&factor%5Bfpw_p%5D=${POWER}&factor%5Bvh_hr%5D=${HASHRATE}&factor%5Bvh_p%5D=${POWER}&factor%5Bcost%5D=0.1&factor%5Bcost_currency%5D=USD&sort=Profitability24&volume=0&revenue=24h&factor%5Bexchanges%5D%5B%5D=&factor%5Bexchanges%5D%5B%5D=binance&factor%5Bexchanges%5D%5B%5D=bitfinex&factor%5Bexchanges%5D%5B%5D=bitforex&factor%5Bexchanges%5D%5B%5D=bittrex&factor%5Bexchanges%5D%5B%5D=coinex&factor%5Bexchanges%5D%5B%5D=exmo&factor%5Bexchanges%5D%5B%5D=gate&factor%5Bexchanges%5D%5B%5D=graviex&factor%5Bexchanges%5D%5B%5D=hitbtc&factor%5Bexchanges%5D%5B%5D=ogre&factor%5Bexchanges%5D%5B%5D=poloniex&factor%5Bexchanges%5D%5B%5D=xeggex&dataset=&commit=Calculate`;

    const response = await fetch(url);
    const result = await response.text();
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(result, "text/html");
    const htmlElement = htmlDocument.documentElement;
    let tds;
    if (checkNameInCustomMiners(name)) {
      tds = htmlElement.querySelectorAll(
        "body table tbody > tr.table-success > td:nth-child(8)"
      );
    } else {
      tds = htmlElement.querySelectorAll(
        "body table tbody > tr:nth-child(1) > td:nth-child(8)"
      );
    }
    if (ALGORITHM == "e4g") {
      console.log(name);
      tds = htmlElement.querySelectorAll(
        "body table tbody > tr:nth-child(2) > td:nth-child(8)"
      );
    }

    const tdsArray = Array.from(tds);
    let usdRev = filterDollarSignTDElements(tdsArray).innerText;
    usdRev = usdRev.split("\n").filter((line: string) => line.trim() !== "");

    const usdRevString = usdRev[0].replace(/\$/g, "").replace(/,/g, "");
    const revenue = parseFloat(
      (Number(usdRevString) * Number(exchangeRate)).toFixed(2)
    );

    return revenue;
  } catch (error) {
    console.log("error", error);
  }
}
function calculateProfits(
  globalPowerCost: number,
  power: number,
  revenue: number,
  price: number,
  globalHeatCost: number,
  withHeat: boolean
) {
  // Krok 1: Przelicz moc maszyny na kilowaty (kW)
  const mocMaszynyWKW = power / 1000;

  // Krok 2: Oblicz dzienną konsumpcję energii elektrycznej przez maszynę w kilowatogodzinach (kWh)
  const dziennaKonsumpcjaKWh = mocMaszynyWKW * 24;

  // Krok 3: Oblicz koszt dzienny za prąd w walucie (np. PLN)
  const powerCost = Number(
    (dziennaKonsumpcjaKWh * (globalPowerCost / 100)).toFixed(2)
  );
  let profit = Number((revenue - powerCost).toFixed(2));

  const heatProfit = calculateHeatProfit(power, globalHeatCost);

  if (withHeat) {
    profit = Number((profit + heatProfit).toFixed(2));
  }
  let daysToReachCost = Math.ceil(price / profit);
  if (daysToReachCost <= 0) {
    daysToReachCost = Infinity;
  }

  return {
    profit,
    powerCost,
    daysToReachCost,
    heatProfit,
  };
}

function calculateHeatProfit(minerPower: number, globalHeatPrice: number) {
  // Przelicznik z Watt na kWh
  const wattToKwh = 1 / 1000;
  // Procent energii, który zostaje zamieniony na ciepło
  const percentConvertedToHeat = 0.8;
  // Przelicznik z kWh na MJ
  const kWhToMJ = 3.6;
  // Przelicznik z GJ na MJ
  const GJtoMJ = 1000;
  // Koszt ciepła w złotych za 1 MJ
  const costPerMJ = globalHeatPrice / GJtoMJ;

  // Przeliczenie mocy koparki z Watt na kWh
  const minerPowerKwh = minerPower * wattToKwh;
  // Obliczenie ilości ciepła wygenerowanego w MJ
  const heatGenerated = minerPowerKwh * percentConvertedToHeat * kWhToMJ;
  // Obliczenie zarobku z ciepła za godzinę
  const profitPerHour = heatGenerated * costPerMJ;

  // Zarobek na dobę
  const profit = profitPerHour * 24;

  return Number(profit.toFixed(2));
}

function filterDollarSignTDElements(tds: any) {
  const filteredTd = tds.find((td: any) => td.textContent.includes("$"));
  return filteredTd;
}
function checkNameInCustomMiners(minerName: string) {
  const customMiners = [
    "Antminer Innosilicon A10 Pro 6G 500Mh",
    "Antminer Innosilicon A10 Pro 7G 720Mh",
    "芯盛电子 Antminer A11",
  ];

  return customMiners.includes(minerName);
}

function recalculateHashrate(algorithm: any, jednostki: any, hashrate: any) {
  if (jednostki == "kSol/s") {
    return hashrate;
  }
  const data = [
    {
      name: "eth",
      przelicznik: "Mh/s",
    },
    {
      name: "e4g",
      przelicznik: "Mh/s",
    },
    {
      name: "hh",
      przelicznik: "Th/s",
    },
    {
      name: "zh",
      przelicznik: "h/s",
    },
    {
      name: "cnh",
      przelicznik: "h/s",
    },
    {
      name: "cng",
      przelicznik: "h/s",
    },
    {
      name: "s5r",
      przelicznik: "Gh/s",
    },
    {
      name: "cx",
      przelicznik: "h/s",
    },
    {
      name: "ds",
      przelicznik: "kh/s",
    },
    {
      name: "cc",
      przelicznik: "h/s",
    },
    {
      name: "cr29",
      przelicznik: "h/s",
    },
    {
      name: "ct32",
      przelicznik: "h/s",
    },
    {
      name: "eqb",
      przelicznik: "h/s",
    },
    {
      name: "b3",
      przelicznik: "Gh/s",
    },
    {
      name: "ns",
      przelicznik: "kh/s",
    },
    {
      name: "al",
      przelicznik: "Mh/s",
    },
    {
      name: "ops",
      przelicznik: "Mh/s",
    },
    {
      name: "ir",
      przelicznik: "Gh/s",
    },
    {
      name: "zlh",
      przelicznik: "h/s",
    },
    {
      name: "kpw",
      przelicznik: "Mh/s",
    },
    {
      name: "ppw",
      przelicznik: "Mh/s",
    },
    {
      name: "nx",
      przelicznik: "Mh/s",
    },
    {
      name: "fpw",
      przelicznik: "Mh/s",
    },
    {
      name: "vh",
      przelicznik: "Mh/s",
    },

    //////////////

    {
      name: "sha256",
      przelicznik: "Th/s",
    },
    {
      name: "scrypt",
      przelicznik: "Gh/s",
    },
    {
      name: "eq",
      przelicznik: "kh/s",
    },
    {
      name: "kd",
      przelicznik: "Th/s",
    },
    {
      name: "x11",
      przelicznik: "Gh/s",
    },
    {
      name: "esg",
      przelicznik: "Gh/s",
    },
    {
      name: "hk",
      przelicznik: "Th/s",
    },
    {
      name: "sia",
      przelicznik: "Th/s",
    },
    {
      name: "qk",
      przelicznik: "Gh/s",
    },
    {
      name: "qb",
      przelicznik: "Gh/s",
    },
    {
      name: "mg",
      przelicznik: "Gh/s",
    },
    {
      name: "sk",
      przelicznik: "Gh/s",
    },
    {
      name: "lbry",
      przelicznik: "Gh/s",
    },
    {
      name: "bk14",
      przelicznik: "Gh/s",
    },
    {
      name: "cn",
      przelicznik: "kh/s",
    },
    {
      name: "cst",
      przelicznik: "kh/s",
    },
    {
      name: "lre",
      przelicznik: "Gh/s",
    },
    {
      name: "bcd",
      przelicznik: "Mh/s",
    },
    {
      name: "l2z",
      przelicznik: "Mh/s",
    },
    {
      name: "zk",
      przelicznik: "Mh/s",
    },
    {
      name: "kec",
      przelicznik: "Gh/s",
    },
    {
      name: "gro",
      przelicznik: "Gh/s",
    },
    {
      name: "ct32",
      przelicznik: "h/s",
    },
    {
      name: "rmx",
      przelicznik: "Th/s",
    },
    {
      name: "s3x",
      przelicznik: "Mh/s",
    },
  ];
  // Find the matching object in the data array based on the provided algorithm
  const algorithmData = data.find((item) => item.name === algorithm);
  // Check if the algorithm exists in the data array
  if (!algorithmData) {
    throw new Error(
      `AlgorithmData ${algorithmData} not found in the data array. Algorithm: ${algorithm}`
    );
  }

  // Convert the input hashrate to Th/s for further calculations
  let hashrateInTh = hashrate;
  if (jednostki === "Gh/s") {
    hashrateInTh /= 1000;
  } else if (jednostki === "Mh/s") {
    hashrateInTh /= 1e6;
  } else if (jednostki === "kh/s") {
    hashrateInTh /= 1e9;
  } else if (jednostki !== "Th/s") {
    console.log(jednostki);
    throw new Error("Invalid jednostki value for the algorithm.");
  }

  let result;
  if (algorithmData.przelicznik === "Th/s") {
    result = hashrateInTh.toFixed(2);
  } else if (algorithmData.przelicznik === "Gh/s") {
    result = (hashrateInTh * 1000).toFixed(2);
  } else if (algorithmData.przelicznik === "Mh/s") {
    result = (hashrateInTh * 1e6).toFixed(2);
  } else if (algorithmData.przelicznik === "kh/s") {
    result = (hashrateInTh * 1e9).toFixed(2);
  } else {
    throw new Error("Invalid przelicznik value for the algorithm.");
  }

  return result;
}
